/**
 * Watermark Component
 *
 * Displays a subtle "tools.dance" watermark for free-tier studios
 * on public embeddable pages (Team Bios, Birthday Widget, etc.).
 */

import React from 'react';
import { Box, Link, Typography } from '@mui/material';

interface WatermarkProps {
  textColor?: string;
  shouldDisplay: boolean;
}

const Watermark: React.FC<WatermarkProps> = ({
  textColor = '#1F1F1F',
  shouldDisplay,
}) => {
  if (!shouldDisplay) {
    return null;
  }

  return (
    <Box
      sx={{
        width: '100%',
        textAlign: 'center',
        py: 2,
        mt: 0,
      }}
    >
      <Link
        href="https://tools.dance"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'none',
            opacity: 0.7,
          },
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: textColor,
            fontSize: '0.875rem',
            opacity: 0.6,
            fontWeight: 400,
          }}
        >
          tools.dance
        </Typography>
      </Link>
    </Box>
  );
};

export default Watermark;
